import axios from 'axios'
import qs from 'qs'
import store from '@/store'
import router from '@/router'
import {
  DecryptCBC,
  EncryptCBC,
  DecryptECB,
  EncryptECB,
  EncryptRAS,
  getUUID,
} from '@/axios/crypto.js'
import {
  Message
} from 'element-ui';


var encryptFlag = '0'
var url = ''
//test
axios.defaults.baseURL = store.state.app.serverName
//设置默认请求头
axios.defaults.headers = {
  'Content-Type': 'application/x-www-form-urlencoded',
}
axios.defaults.timeout = 60000

//请求拦截器
axios.interceptors.request.use(config => {
  url = config.url
  var bool1 = config.url.indexOf("queryPublicKey")
  var bool2 = config.url.indexOf("upload")
  var bool3 = config.url.indexOf("download")
  var bool4 = config.url.indexOf("show")
  var bool5 = config.url.indexOf("import")
  var bool6 = config.url.indexOf("export")
  var bool7 = config.url.indexOf("order")
  // if(encryptFlag == '1' && config.url.indexOf('activiti/service/model')){
  //   encryptFlag= '0'
  // }else {
  //    encryptFlag= '1'
  // }

  config.headers.token = localStorage.getItem('token')
  config.headers.userId = localStorage.getItem('userId')
  config.headers.menuId = localStorage.getItem('menuId')
  config.headers.belongId = localStorage.getItem('belongId')
  config.headers.os = 'web'

  var publicKey = localStorage.getItem('publicKey')
  var KEY = getUUID()
  var IV = getUUID()
  config.headers.key = EncryptRAS(KEY, publicKey)
  config.headers.iv = EncryptRAS(IV, publicKey)
  config.headers.publicKey = publicKey
  config.headers.encryptFlag = encryptFlag

  if (bool1 > 0 || bool2 > 0 || bool3 > 0 || bool4 > 0 || bool5 > 0 || bool6 > 0) {
    return config
  } else {
    if (encryptFlag == '1') {
      if (config.method == 'get') {
        if (config.params) {
          for (let key of Object.keys(config.params)) {
            if (config.params[key] || config.params[key] == 0) {
              config.params[key] = EncryptCBC(encodeURIComponent(config.params[key].toString()), KEY, IV)
            } else {
              config.params[key] = EncryptCBC(encodeURIComponent(''), KEY, IV)
            }
          }
        }
        config.params['getParam'] = EncryptCBC(encodeURIComponent(''), KEY, IV)

      } else if (config.method == 'post') {
        if (config.data) {
          for (let key of Object.keys(config.data)) {
            if (config.data[key] || config.data[key] == 0) {
              config.data[key] = EncryptCBC(encodeURIComponent(config.data[key].toString()), KEY, IV)
            } else {
              config.data[key] = EncryptCBC(encodeURIComponent(''), KEY, IV)
            }
          }
        }
        config.data['postParam'] = EncryptCBC(encodeURIComponent(''), KEY, IV)

        config.data = qs.stringify(config.data);
      }
    } else {

      if (config.method == 'get') {
        if (config.params) {
          for (let key of Object.keys(config.params)) {
            if (config.params[key] || config.params[key] == 0) {
              config.params[key] = encodeURIComponent(config.params[key].toString())
            } else {
              config.params[key] = encodeURIComponent('')
            }
          }
        }


      } else if (config.method == 'post') {
        if (config.data) {
          for (let key of Object.keys(config.data)) {
            if (config.data[key] || config.data[key] == 0) {
              config.data[key] = encodeURIComponent(config.data[key].toString())
            } else {
              config.data[key] = encodeURIComponent('')
            }
          }
        }
        config.data['postParam'] = encodeURIComponent('')

        config.data = qs.stringify(config.data);
      }




    }
    return config
  }

}, error => {

  return Promise.reject(error)
})

//响应拦截器即异常处理
axios.interceptors.response.use(response => {
  if (url.indexOf('download') > 0 || url.indexOf('export') > 0) {
    console.log(url)
    return response
  }
  if (encryptFlag == '1' && url.indexOf('activiti/service/model') < 0) {
    var a = DecryptCBC(response.data)
    response.data = JSON.parse(a)
  }
  if (response.data.code == '0') {
    var t = typeof response.data.data
    if (t == 'string') {
      try {
        response.data.data = JSON.parse(response.data.data)
      } catch (e) {
        return response
      }
    }
    return response
  } else {
    return response
    // Message({
    //   type: 'error',
    //   message: '操作失败!error code:' + response.data.code + ';' + response.data.msg
    // })
    // return Promise.reject()
  }
}, err => {
  console.log("err" + JSON.stringify(err))
  if (err && err.response) {
    switch (err.response.status) {
      case 203:
        err.message = '登录超时，请重新登录'
        router.replace({
          path: '/login',
          query: {
            error: err.message
          },
        })
        break;
      case 400:
        err.message = '错误请求'
        break;
      case 401:
        err.message = '未授权，请重新登录'
        router.replace({
          path: '/login',
          query: {
            error: err.message
          },
        })
        break;
      case 403:
        err.message = '拒绝访问'
        break;
      case 404:
        err.message = '请求错误,未找到该资源'
        break;
      case 405:
        err.message = '请求方法未允许'
        break;
      case 408:
        err.message = '请求超时'
        break;
      case 500:
        err.message = '服务器端出错，请联系开发人员'
        break;
      case 501:
        err.message = '微服务重启，暂未获取心跳，请稍等'
        break;
      case 502:
        err.message = '网络错误'
        break;
      case 503:
        err.message = '服务不可用'
        break;
      case 504:
        err.message = '网络超时'
        break;
      case 505:
        err.message = 'http版本不支持该请求'
        break;
      case 600:
        err.message = '登录超时，请重新登陆'
        router.replace({
          path: '/login',
          query: {
            error: err.message
          },
        })
        break;
      case 601:
        err.message = '用户在另一地点登录！'
        router.replace({
          path: '/login',
          query: {
            error: err.message
          },
        })
        break;
      default:
        err.message = `连接错误${err.response.status}`
    }

  } else {
    err.message = "连接到服务器失败"
  }
  // Message({
  //   type: 'error',
  //   message: '操作失败!' + err.message
  // })
  // var result = {
  //   data: {
  //     code: err.response.status,
  //     data: '',
  //     msg: err.message
  //   }
  // }
  return Promise.reject()
})



export default {
  //get请求
  get(url, param) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url,
        params: param
      }).then(response => {
        //response.data=JSON.parse(Decrypt(response.data) )
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  //post请求
  post(url, param) {

    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url,
        data: param
      }).then(response => {
        //response.data=JSON.parse(Decrypt(response.data) )
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
};



// WEBPACK FOOTER //
// ./src/axios/axios.js